import { useState, useEffect } from "react";

export default function CalendarNav({ weekStart, onNavigate, disabled }) {
  const [viewDate, setViewDate] = useState(() => new Date(weekStart));
  useEffect(() => { setViewDate(new Date(weekStart)); }, [weekStart]);

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const firstDow = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month, d));
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const ws = new Date(weekStart); ws.setHours(0, 0, 0, 0);
  const we = new Date(ws.getTime() + 6 * 24 * 60 * 60 * 1000);
  const isSelectedWeek = (week) => week.some(d => d && d >= ws && d <= we);

  const today = new Date(); today.setHours(0, 0, 0, 0);
  const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const DOW = ["Su","Mo","Tu","We","Th","Fr","Sa"];
  const nb = { background: "none", border: "none", color: "rgba(255,255,255,0.5)", cursor: "pointer", fontSize: 16, padding: "2px 8px", borderRadius: 4, lineHeight: 1 };

  return (
    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: "16px 20px", marginBottom: 24 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ display: "flex", gap: 2 }}>
          <button style={nb} onClick={() => setViewDate(new Date(year - 1, month, 1))} title="Previous year">«</button>
          <button style={nb} onClick={() => setViewDate(new Date(year, month - 1, 1))} title="Previous month">‹</button>
        </div>
        <span style={{ color: "#f0ede8", fontSize: 13, fontWeight: 500 }}>{MONTHS[month]} {year}</span>
        <div style={{ display: "flex", gap: 2 }}>
          <button style={nb} onClick={() => setViewDate(new Date(year, month + 1, 1))} title="Next month">›</button>
          <button style={nb} onClick={() => setViewDate(new Date(year + 1, month, 1))} title="Next year">»</button>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", marginBottom: 4 }}>
        {DOW.map(d => <div key={d} style={{ textAlign: "center", fontSize: 10, color: "rgba(255,255,255,0.3)", padding: "2px 0" }}>{d}</div>)}
      </div>
      {weeks.map((week, wi) => {
        const selected = isSelectedWeek(week);
        return (
          <div key={wi}
            onClick={() => { if (!disabled) { const d = week.find(x => x); if (d) onNavigate(d); } }}
            style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", borderRadius: 8, marginBottom: 2, background: selected ? "rgba(99,102,241,0.2)" : "transparent", outline: selected ? "1px solid rgba(99,102,241,0.4)" : "none", cursor: disabled ? "default" : "pointer" }}>
            {week.map((day, di) => {
              const isToday = day && day.toDateString() === today.toDateString();
              const inMonth = day && day.getMonth() === month;
              return (
                <div key={di} style={{ textAlign: "center", fontSize: 12, padding: "5px 2px", color: !day ? "transparent" : isToday ? "#c7d2fe" : inMonth ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.2)", fontWeight: isToday ? 700 : 400 }}>
                  {day ? day.getDate() : "·"}
                </div>
              );
            })}
          </div>
        );
      })}
      {disabled && <div style={{ textAlign: "center", fontSize: 11, color: "rgba(255,255,255,0.2)", marginTop: 8 }}>Connect a calendar to navigate weeks</div>}
    </div>
  );
}
